import React from 'react';
import classnames from 'classnames';
import {useSelector} from 'react-redux';

import {Store} from 'src/types/store';
import usePlatformContext from 'src/hooks/usePlatform';
import {useMediaQuery} from 'src/hooks/useMediaQuery';

const Loading = () => {
  const {image, firstName, lastName} = useSelector((state: Store) => state.student);
  const {isIonic} = usePlatformContext();
  const mq = useMediaQuery();

  return (
    <div className="portfolio-loading" data-testid="portfolio-loading">
      <div className="container" data-testid="earnings-sidebar-layout">
        <div
          className={classnames('portfolio-loading-about-me', {
            'ionic-about-me': mq.MS_AND_DOWN && isIonic,
          })}
        >
          <div className="portfolio-loading-about-me-avatar-container">
            {image ? (
              <img src={image} className="portfolio-loading-about-me-avatar" alt="" />
            ) : (
              <div className="portfolio-loading-about-me-avatar shimmer"></div>
            )}
          </div>
          <div className="portfolio-loading-about-me-info">
            <div className="portfolio-loading-about-me-info-name-and-class">
              {firstName && lastName ? (
                <p className="portfolio-loading-about-me-name">
                  {firstName} {lastName}
                </p>
              ) : (
                <div className="portfolio-loading-body-text medium shimmer"></div>
              )}
              <div className="portfolio-loading-body-text small shimmer"></div>
            </div>
            <div className="portfolio-loading-body-text small shimmer"></div>
            <div className="portfolio-loading-body-text x-small shimmer"></div>
            <div className="portfolio-loading-body-text small shimmer"></div>
          </div>
        </div>
        <div className="portfolio-loading-card">
          <div className="portfolio-loading-body-title shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
        </div>
        <div className="portfolio-loading-card">
          <div className="portfolio-loading-body-title shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
        </div>
        <div className="portfolio-loading-card">
          <div className="portfolio-loading-body-title shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
        </div>
        <div className="portfolio-loading-card">
          <div className="portfolio-loading-body-title shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
          <div className="portfolio-loading-body-text shimmer"></div>
        </div>
      </div>
      <div className="portfolio-loading-sidebar">
        <div className="portfolio-loading-sidebar-section">
          <div className="portfolio-loading-body-text no-margin shimmer"></div>
        </div>
        <div className="portfolio-loading-sidebar-section">
          <div className="portfolio-loading-body-text small shimmer"></div>
          <div className="portfolio-loading-body-text x-small shimmer"></div>
          <div className="portfolio-loading-body-text small shimmer"></div>
        </div>
        <div className="portfolio-loading-sidebar-section">
          <div className="portfolio-loading-body-text small shimmer"></div>
          <div className="portfolio-loading-body-text x-small shimmer"></div>
          <div className="portfolio-loading-body-text small shimmer"></div>
          <div className="portfolio-loading-body-text x-small shimmer"></div>
          <div className="portfolio-loading-body-text small shimmer"></div>
        </div>
        <div className="portfolio-loading-sidebar-section">
          <div className="portfolio-loading-body-text small shimmer"></div>
          <div className="portfolio-loading-body-text x-small shimmer"></div>
          <div className="portfolio-loading-body-text small shimmer"></div>
        </div>
        <div className="portfolio-loading-sidebar-section">
          <div className="portfolio-loading-body-text small shimmer"></div>
          <div className="portfolio-loading-body-text x-small shimmer"></div>
        </div>
        {mq.MD_AND_UP && (
          <div className="portfolio-loading-sidebar-section end">
            <div className="portfolio-loading-body-button shimmer"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Loading;
